import { Component, HostListener, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SkeletonSizeBase } from '../../../common';

@Component({
  selector: 'skc-gallery-youtube',
  templateUrl: './gallery-youtube.component.html',
  styleUrls: ['./gallery-youtube.component.less']
})
export class GalleryYoutubeComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-total') total;
  @Input('skc-responsive') responsive;
  videos: number[] = [];
  responsiveWidth = '320px';
  size;
  constructor() {
    super();
    this.calcVideoWidth();
  }

  ngOnInit() {}

  @HostListener('window:resize')
  onWindowResize() {
    this.calcVideoWidth();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.total) {
      this.numberToArray();
    }
    if (changes.responsive) {
      this.responsive = changes.responsive.currentValue;
      this.calcVideoWidth();
    }
  }

  private numberToArray() {
    this.videos = new Array(this.total).fill({});
  }

  private calcVideoWidth() {
    if (!this.responsive) {
      this.responsiveWidth = '320px';
      return;
    }
    this.size = document.querySelector('body').offsetWidth;
    if (this.size < 576) {
      this.responsiveWidth = '100%';
    } else if (this.size < 992) {
      this.responsiveWidth = '220px';
    } else if (this.size < 1600) {
      this.responsiveWidth = '320px';
    } else {
      this.responsiveWidth = '450px';
    }
  }
}
